import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useEffect } from 'react';
import { AgreementWizardPage } from './pages/AgreementWizardPage';
import { AgreementSummaryPage } from './pages/AgreementSummaryPage';
import OverdueCollectionsPage from './pages/OverdueCollectionsPage';
import DashboardPage from './pages/DashboardPage';
import SyncStatusBanner from './components/SyncStatusBanner';
import { initializePWA } from './utils/pwaRegistration';
import './App.css';

function App() {
  // Initialize PWA on app start
  useEffect(() => {
    initializePWA();
  }, []);

  return (
    <Router>
      <div className="App">
        {/* Global Sync Status Banner */}
        <SyncStatusBanner />
        
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 4000,
            style: { background: '#363636', color: '#fff' },
            success: { duration: 3000, iconTheme: { primary: '#4ade80', secondary: '#fff' } },
            error: { duration: 4000, iconTheme: { primary: '#ef4444', secondary: '#fff' } },
          }}
        />
        <Routes>
          <Route path="/" element={
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
              <div className="text-center">
                <h1 className="text-4xl font-bold text-gray-900 mb-4">
                  Kist Manager - إدارة البيع بالتقسيط
                </h1>
                <p className="text-xl text-gray-600 mb-8">
                  Arabic RTL installment payment management system
                </p>
                <div className="space-y-4">
                  <Link
                    to="/dashboard"
                    className="inline-flex items-center px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-lg"
                  >
                    لوحة المعلومات - Dashboard
                  </Link>
                  <br />
                  <Link
                    to="/agreement-wizard"
                    className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-lg"
                  >
                    إنشاء اتفاقية جديدة - Create New Agreement
                  </Link>
                  <br />
                  <Link
                    to="/overdue-collections"
                    className="inline-flex items-center px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-lg"
                  >
                    تحصيل المتأخرات - Overdue Collections
                  </Link>
                </div>
              </div>
            </div>
          } />
          <Route path="/agreement-wizard" element={<AgreementWizardPage />} />
          <Route path="/a/:shortCode" element={<AgreementSummaryPage />} />
          <Route path="/overdue-collections" element={<OverdueCollectionsPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 